import { List, ListItem, ListIcon } from "@chakra-ui/react";
import React from "react";
import { needsReviewIconProps } from "../../../atoms/NeedsReview";

export function TransactionsNeedsReviewList({
  items,
}: {
  items: JSX.Element[];
}) {
  return (
    <List spacing="3">
      {Object.entries(items).map(([idx, needsReviewItem]) => (
        <ListItem key={idx} display="flex">
          <ListIcon mt="0.3em" {...needsReviewIconProps} />
          {needsReviewItem}
        </ListItem>
      ))}
    </List>
  );
}
